<div class="card" *ngIf="HasHeader">
  <div class="d-md-flex align-items-center bg-white p-2 card-body" >
  <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Blocchi:</h5>
    <span  class="testentry badge badge-danger badge-pill px-3 font-weight-bold font-14 ">{{items?.length ?? 0}}</span>
  </span>
    <div class="ml-auto mt-3 mt-md-0" >
      <button type="button" (click)="Open()" *ngIf="HasAddButton && permission.isPermitted('gestione-prodotti')" class="btn btn-cyan rounded-pill p-2" ><i
        class="fas fa-plus  font-14 mr-1 text-white"></i>
        <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
      </button>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
          <tr>
            <th scope="col">Blocco</th>
            <th scope="col">Tag</th>
            <th scope="col" *ngIf="permission.isPermitted('gestione-blocchi') && Editable">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td (click)='Open(item)'>
              <span class="text-dark font-medium font-16">
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                 <span class="nome">
                  {{ item.nome }}
                 </span>
              </span>
            </td>
            <td (click)='Open(item)'>
              <span class="text-dark font-medium font-16">
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                <span class="marker">
                  {{ item.marker }}
                 </span>
              </span>
            </td>
            <td class="align-middle" *ngIf="permission.isPermitted('gestione-blocchi') && Editable">
              <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='Open(item)'>
                <i class="fas fa-pencil-alt"></i>
              </a>
              <a href="javascript:void(0)" class="link font-16 text-danger font-medium mr-2" (click)='delete(item)'>
                <i class="fas fa-trash-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
